export const MAKES = [
  "BMW", "Mercedes-Benz", "Audi", "Volvo", "Volkswagen",
  "Toyota", "Mazda", "Honda", "Cupra",
];

export const FUELS = ["Petrol", "Diesel", "Hybrid", "Electric"];
export const TRANSMISSIONS = ["Manual", "Automatic"];
export const BODY_TYPES = ["Sedan", "Estate", "Hatchback", "SUV", "Convertible"];

export const COUNTRIES = [
  "Germany", "Netherlands", "Belgium", "Poland", "France",
  "Italy", "Spain", "Austria", "Portugal",
];

export const PRIORITIES = [
  { key: "price", label: "Price" },
  { key: "mileage", label: "Mileage" },
  { key: "maintenance", label: "Maintenance history" },
  { key: "equipment", label: "Equipment" },
  { key: "year", label: "Year" },
  { key: "location", label: "Location" },
  { key: "value", label: "Overall value" },
];

export const PRIORITY_PRESETS = [
  { slug: "best-value", label: "Best value", keys: ["value", "price"] },
  { slug: "lowest-mileage", label: "Lowest mileage", keys: ["mileage"] },
  { slug: "lowest-price", label: "Lowest price", keys: ["price"] },
  { slug: "best-maintenance", label: "Best maintenance", keys: ["maintenance"] },
];

export const emptyCriteria = () => ({
  make: null, model: null, generation: null, version: null,
  min_year: null, max_year: null,
  min_price: null, max_price: null,
  max_mileage: null,
  fuel: null, transmission: null, body_type: null, trim: null,
  countries: [], priorities: [], exclude_variants: [],
});
